import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const offlineCourses = [
  { icon: '🏆', title: 'Master Accountant using Tally', badge: 'Premium', badgeColor: '#e67e22', desc: 'A premium course designed to bridge the gap between academic learning and industry needs.', duration: '4 Months', link: 'https://tallyeducation.com/tepl/offline-courses/' },
  { icon: '🎓', title: 'Tally Certification with Online Internship', badge: 'With Internship', badgeColor: '#27ae60', desc: 'Get hands-on Accounting experience with Tally\'s NEP-aligned Online Internship.', duration: '3 Months', link: 'https://tallyeducation.com/tepl/online-internship/' },
  { icon: '📊', title: 'Tally Certification with GST Simulation', badge: 'Popular', badgeColor: '#e67e22', desc: 'A Dynamic Platform for Practising GST Returns with Tally Certification to Level Up Your Career.', duration: '2 Months', link: 'https://tallyeducation.com/tepl/gst-simulation/' },
  { icon: '💻', title: 'Office Automation', badge: 'Beginner', badgeColor: '#90b732', desc: 'Gain essential skills in Basic Computing, MS Word, Excel & PowerPoint.', duration: '1.5 Months', link: 'https://tallyeducation.com/tepl/offline-courses/office-automation/' },
  { icon: '💰', title: 'Complete Guide to Payroll & Income Tax', badge: 'Specialized', badgeColor: '#8e44ad', desc: 'Manage payroll & taxes with TallyPrime — process salaries & ensure compliance.', duration: '2 Months', link: 'https://tallyeducation.com/tepl/offline-courses/complete-guide-to-payroll-income-tax/' },
  { icon: '📦', title: 'Complete Guide to Inventory Management', badge: 'Specialized', badgeColor: '#8e44ad', desc: 'Master inventory control with TallyPrime — track, manage & optimize seamlessly.', duration: '2 Months', link: 'https://tallyeducation.com/tepl/offline-courses/complete-guide-to-inventory-management/' },
  { icon: '📘', title: 'TallyEssential', badge: 'Beginner', badgeColor: '#90b732', desc: 'A Complete Guide on Business Accounting.', duration: '2 Months', link: 'https://tallyeducation.com/tepl/offline-courses/' },
  { icon: '📗', title: 'TallyProfessional', badge: 'Advanced', badgeColor: '#4d3d6c', desc: 'A Complete Guide on Advanced Business Accounting and Indian Taxation.', duration: '3 Months', link: 'https://tallyeducation.com/tepl/offline-courses/' },
  { icon: '🧾', title: 'GST using TallyPrime', badge: 'Popular', badgeColor: '#e67e22', desc: 'A Complete Guide on Goods and Services Tax (GST).', duration: '1.5 Months', link: 'https://tallyeducation.com/tepl/offline-courses/' },
  { icon: '📋', title: 'TDS using Tally', badge: 'Specialized', badgeColor: '#8e44ad', desc: 'A Complete Guide on Tax Deducted at Source (TDS).', duration: '1 Month', link: 'https://tallyeducation.com/tepl/offline-courses/' },
  { icon: '🌍', title: 'GCC VAT using TallyPrime', badge: 'International', badgeColor: '#2980b9', desc: 'A Complete Guide on GCC VAT Concepts and its Usage.', duration: '1 Month', link: 'https://tallyeducation.com/tepl/offline-courses/' },
  { icon: '🌐', title: 'TallyEssential International', badge: 'International', badgeColor: '#2980b9', desc: 'A Complete Guide on Business Accounting in Middle East Countries.', duration: '2 Months', link: 'https://tallyeducation.com/tepl/offline-courses/' },
  { icon: '⚙️', title: 'TDL Essential International', badge: 'Advanced', badgeColor: '#4d3d6c', desc: 'Develop and Deploy Solutions using TDL for TallyPrime.', duration: '2 Months', link: 'https://tallyeducation.com/tepl/offline-courses/' },
];

const onlineCourses = [
  { icon: '📦', title: 'Simplifying Inventory Management with TallyPrime', badge: 'Self-paced', badgeColor: '#90b732', desc: 'Optimise stock, cut costs, and streamline inventory with efficient tracking and control.' },
  { icon: '🧾', title: 'GST Filing with TallyPrime', badge: 'Popular', badgeColor: '#e67e22', desc: 'Gain expertise in GST compliance, manage returns seamlessly, and handle tax processes with accuracy.' },
  { icon: '📊', title: 'Accounts Receivables & Payables with TallyPrime', badge: 'Self-paced', badgeColor: '#90b732', desc: 'Streamline invoicing, track payments, and manage receivables & payables efficiently.' },
  { icon: '⚙️', title: 'TDL Essential', badge: 'Advanced', badgeColor: '#4d3d6c', desc: 'Develop and Deploy Solutions using TDL for TallyPrime.' },
  { icon: '💼', title: 'Mastering Payroll Management with Tally', badge: 'Specialized', badgeColor: '#8e44ad', desc: 'Acquire practical skills in Payroll and HR Management using Tally.' },
  { icon: '📈', title: 'Data Analysis and Verification Tools', badge: 'Self-paced', badgeColor: '#90b732', desc: 'Excel in financial analysis, execute high-value transactions, and data validation.' },
  { icon: '🗃️', title: 'Inventory Management', badge: 'Self-paced', badgeColor: '#90b732', desc: 'Excel in inventory management through advanced techniques and practical applications.' },
  { icon: '📘', title: 'TallyPrime Basics', badge: 'Beginner', badgeColor: '#27ae60', desc: 'Excel in precise transaction recording, accounts management, and bank reconciliation.' },
  { icon: '🧮', title: 'TallyPrime with GST', badge: 'Popular', badgeColor: '#e67e22', desc: 'Excel in intricate tax landscapes, ensure GST compliance precision with TallyPrime expertise.' },
  { icon: '📉', title: 'Microsoft Excel - Beginner to Advanced', badge: 'Self-paced', badgeColor: '#90b732', desc: 'Master Microsoft Excel from basic functions to advanced data analysis.' },
  { icon: '🖥️', title: 'Computer Basics with Microsoft Office', badge: 'Beginner', badgeColor: '#27ae60', desc: 'Master essential computer skills and effectively use Microsoft Office applications.' },
  { icon: '📒', title: 'Principles of Tally Bookkeeping', badge: 'Beginner', badgeColor: '#27ae60', desc: 'Excel in accounting transactions, precise bookkeeping, and Tally proficiency.' },
  { icon: '📑', title: 'TallyPrime with GST Fundamentals', badge: 'Self-paced', badgeColor: '#90b732', desc: 'Excel in GST fundamentals, compliance, and leveraging TallyPrime expertise.' },
  { icon: '💹', title: 'Financial Markets and Services', badge: 'Self-paced', badgeColor: '#2980b9', desc: 'Excel in comprehensive understanding of financial markets and refined analytical skills.' },
];

const freeCourses = [
  { icon: '💵', title: 'Smart Cash Management', badge: 'Free', badgeColor: '#27ae60', desc: 'Master cash management, understand accounting basics, manage receivables/payables, and streamline transactions.' },
  { icon: '📜', title: 'Short Guide to Goods and Services Tax (GST)', badge: 'Free', badgeColor: '#27ae60', desc: 'Master the complexities of GST, registration, tax structuring, HSN/SAC codes, invoicing, and seamless filing.' },
];

const CourseCard = ({ course, type }) => (
  <div className={`crs-card h-100 ${type === 'online' ? 'crs-card-online' : type === 'free' ? 'crs-card-free' : ''}`}>
    <div className="crs-card-top">
      <span className="crs-icon">{course.icon}</span>
      <span className="crs-badge" style={{ background: course.badgeColor }}>{course.badge}</span>
    </div>
    <h6 className="crs-title">{course.title}</h6>
    <p className="crs-desc">{course.desc}</p>
    {course.duration && (
      <div className="crs-meta">
        <span><i className="bi bi-clock me-1"></i>{course.duration}</span>
        <span><i className="bi bi-building me-1"></i>Classroom</span>
      </div>
    )}
    {!course.duration && (
      <div className="crs-meta">
        <span><i className="bi bi-laptop me-1"></i>Self-paced Online</span>
      </div>
    )}
    <a href={course.link || 'https://tallyeducation.com/tepl/offline-courses/'} target="_blank" rel="noopener noreferrer" className="crs-btn">
      View Details →
    </a>
  </div>
);

const Courses = () => {
  const [tab, setTab] = useState('offline');

  const tabs = [
    { key: 'offline', label: '🏫 Offline Courses', count: offlineCourses.length },
    { key: 'online',  label: '💻 Online Courses',  count: onlineCourses.length },
    { key: 'free',    label: '🎁 Free Courses',     count: freeCourses.length },
  ];

  const current = tab === 'offline' ? offlineCourses : tab === 'online' ? onlineCourses : freeCourses;

  return (
    <>
      <Helmet>
        <title>Tally Courses Damoh | Shrikant Tally Institute | Shrikant Singhai</title>
        <meta name="description" content="Explore all Tally courses at Shrikant Tally Institute Damoh. Tally Essential, Tally Professional, GST Simulation, Payroll, Office Automation, online & free courses. Get Tally Education certified with placement support." />
        <meta name="keywords" content="Tally course Damoh, Tally Professional course, Tally Essential course, GST course Damoh, TallyPrime training, accounting course MP, Tally certification Damoh, online Tally course, offline Tally course, payroll course Tally, TDL course, office automation Damoh, Tally Education courses, Shrikant Tally courses, best Tally course Damoh" />
        <meta property="og:title" content="Tally Courses & Certifications | Shrikant Tally Institute Damoh" />
        <meta property="og:url" content="https://shrikanttallyinstitute.com/courses" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://shrikanttallyinstitute.com/courses" />
      </Helmet>

      <style>{`
        .crs-hero {
          background: linear-gradient(135deg, #4d3d6c 0%, #6b4f9e 60%, #90b732 100%);
          padding: 64px 24px;
          color: #fff;
          position: relative;
          overflow: hidden;
        }
        .crs-hero::before {
          content: '';
          position: absolute;
          top: -80px; right: -80px;
          width: 300px; height: 300px;
          background: rgba(144,183,50,0.15);
          border-radius: 50%;
        }
        .crs-hero h1 { font-size: clamp(1.8rem, 4vw, 2.8rem); font-weight: 800; }
        .crs-hero p  { font-size: 15px; opacity: 0.85; max-width: 520px; }
        .crs-hero-badge {
          display: inline-block;
          background: rgba(255,255,255,0.15);
          border: 1px solid rgba(255,255,255,0.3);
          border-radius: 50px;
          padding: 4px 16px;
          font-size: 12.5px;
          margin-bottom: 14px;
        }
        .crs-enroll-btn {
          background: #fff;
          color: #90b732;
          font-weight: 700;
          border: none;
          border-radius: 8px;
          padding: 11px 28px;
          font-size: 14px;
          text-decoration: none;
          display: inline-block;
          transition: transform 0.2s, box-shadow 0.2s;
        }
        .crs-enroll-btn:hover { transform: translateY(-2px); box-shadow: 0 6px 20px rgba(0,0,0,0.15); color: #6fa020; }

        /* Stats bar */
        .crs-stats-bar {
          background: #4d3d6c;
          padding: 20px 24px;
          display: flex;
          justify-content: center;
          gap: 48px;
          flex-wrap: wrap;
        }
        .crs-stat { text-align: center; color: #fff; }
        .crs-stat .n { font-size: 1.6rem; font-weight: 800; color: #90b732; line-height: 1; }
        .crs-stat .l { font-size: 12px; opacity: 0.75; margin-top: 3px; }

        /* Tabs */
        .crs-tabs-wrap { background: #f8fdf0; padding: 32px 24px 0; }
        .crs-tabs { display: flex; gap: 8px; border-bottom: 2px solid #e0efc0; flex-wrap: wrap; }
        .crs-tab-btn {
          background: none; border: none;
          padding: 10px 24px; font-size: 14px; font-weight: 600; color: #888;
          border-bottom: 3px solid transparent; margin-bottom: -2px;
          cursor: pointer; transition: color 0.2s, border-color 0.2s;
        }
        .crs-tab-btn.active { color: #4d3d6c; border-bottom-color: #90b732; }
        .crs-tab-btn:hover { color: #4d3d6c; }
        .crs-tab-count {
          background: #ecf3d7; color: #4d7a10;
          border-radius: 50px; padding: 1px 8px;
          font-size: 11px; font-weight: 700; margin-left: 6px;
        }
        .crs-tab-btn.active .crs-tab-count { background: #90b732; color: #fff; }

        /* Grid */
        .crs-grid-wrap { background: #f8fdf0; padding: 32px 24px 64px; }

        /* Cards */
        .crs-card {
          background: #fff;
          border-radius: 14px;
          padding: 22px;
          border: 1.5px solid #e8f5c8;
          display: flex; flex-direction: column;
          transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s;
        }
        .crs-card:hover { transform: translateY(-6px); box-shadow: 0 12px 32px rgba(144,183,50,0.15); border-color: #90b732; }
        .crs-card-online { border-color: #d0e8ff; background: linear-gradient(135deg, #fff 80%, #f0f8ff 100%); }
        .crs-card-online:hover { border-color: #2980b9; box-shadow: 0 12px 32px rgba(41,128,185,0.12); }
        .crs-card-free { border-color: #d5f5e3; background: linear-gradient(135deg, #fff 80%, #f0fff4 100%); }
        .crs-card-free:hover { border-color: #27ae60; box-shadow: 0 12px 32px rgba(39,174,96,0.12); }
        .crs-card-top { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
        .crs-icon {
          font-size: 26px; width: 50px; height: 50px;
          background: #ecf3d7; border-radius: 12px;
          display: flex; align-items: center; justify-content: center;
        }
        .crs-card-online .crs-icon { background: #e8f4fd; }
        .crs-card-free .crs-icon { background: #eafaf1; }
        .crs-badge { color: #fff; font-size: 11px; font-weight: 700; border-radius: 50px; padding: 3px 12px; }
        .crs-title { font-size: 14.5px; font-weight: 700; color: #2d2d2d; margin-bottom: 8px; line-height: 1.4; }
        .crs-desc { font-size: 13px; color: #777; line-height: 1.7; flex: 1; margin-bottom: 12px; }
        .crs-meta { display: flex; gap: 12px; font-size: 12px; color: #999; margin-bottom: 14px; }
        .crs-meta i { color: #90b732; }
        .crs-card-online .crs-meta i { color: #2980b9; }
        .crs-card-free .crs-meta i { color: #27ae60; }
        .crs-btn {
          background: #ecf3d7; color: #4d7a10;
          font-size: 13px; font-weight: 700; border-radius: 8px;
          padding: 8px 16px; text-decoration: none; text-align: center;
          transition: background 0.2s, color 0.2s; display: block;
        }
        .crs-btn:hover { background: #90b732; color: #fff; }
        .crs-card-online .crs-btn { background: #e8f4fd; color: #2980b9; }
        .crs-card-online .crs-btn:hover { background: #2980b9; color: #fff; }
        .crs-card-free .crs-btn { background: #eafaf1; color: #27ae60; }
        .crs-card-free .crs-btn:hover { background: #27ae60; color: #fff; }

        /* CTA */
        .crs-cta-strip { background: #4d3d6c; padding: 48px 24px; text-align: center; color: #fff; }
        .crs-cta-strip h3 { font-weight: 800; font-size: 1.6rem; }
        .crs-cta-strip p  { opacity: 0.8; font-size: 14px; max-width: 480px; margin: 10px auto 24px; }
        .crs-cta-strip-btn {
          background: #90b732; color: #fff; font-weight: 700;
          border: none; border-radius: 8px; padding: 12px 32px;
          font-size: 15px; text-decoration: none; display: inline-block;
          transition: transform 0.2s, box-shadow 0.2s;
        }
        .crs-cta-strip-btn:hover { transform: translateY(-2px); box-shadow: 0 6px 20px rgba(144,183,50,0.4); color: #fff; }
      `}</style>

      {/* Hero */}
      <div className="crs-hero">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-7">
              <span className="crs-hero-badge">🎓 Tally Education Authorized Partner</span>
              <h1>Courses & Certifications</h1>
              <p className="mt-2 mb-4">Industry-recognized Tally courses designed to make you job-ready. {offlineCourses.length + onlineCourses.length + freeCourses.length}+ courses across offline, online & free categories.</p>
              <div className="d-flex gap-3 flex-wrap">
                <Link to="/register" className="crs-enroll-btn">Enroll Now →</Link>
                <Link to="/verify" className="crs-enroll-btn" style={{ background: 'rgba(255,255,255,0.15)', color: '#fff', border: '1.5px solid rgba(255,255,255,0.4)' }}>Verify Certificate</Link>
              </div>
            </div>
            <div className="col-md-5 text-center d-none d-md-block">
              <img src="https://tallyeducation.com/tepl/wp-content/themes/TEPL/assets/images/certificate.jpg" alt="Courses" className="img-fluid" style={{ borderRadius: 16, maxHeight: 280, boxShadow: '0 12px 40px rgba(0,0,0,0.2)' }} />
            </div>
          </div>
        </div>
      </div>

      {/* Stats bar */}
      <div className="crs-stats-bar">
        {[
          { n: `${offlineCourses.length}+`, l: 'Offline Courses' },
          { n: `${onlineCourses.length}+`, l: 'Online Courses' },
          { n: `${freeCourses.length}`,    l: 'Free Courses' },
          { n: '12,000+',                  l: 'Students Trained' },
          { n: '80%',                      l: 'Placement Rate' },
        ].map((s, i) => (
          <div key={i} className="crs-stat">
            <div className="n">{s.n}</div>
            <div className="l">{s.l}</div>
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div className="crs-tabs-wrap">
        <div className="container">
          <div className="crs-tabs">
            {tabs.map(t => (
              <button key={t.key} className={`crs-tab-btn ${tab === t.key ? 'active' : ''}`} onClick={() => setTab(t.key)}>
                {t.label} <span className="crs-tab-count">{t.count}</span>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Grid */}
      <div className="crs-grid-wrap">
        <div className="container">
          <div className="row g-4">
            {current.map((course, i) => (
              <div key={i} className="col-sm-6 col-lg-4">
                <CourseCard course={course} type={tab} />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="crs-cta-strip">
        <div className="container">
          <h3>Ready to Start Your Career?</h3>
          <p>Join 12,000+ students who have transformed their careers with Shrikant Tally Institute.</p>
          <Link to="/register" className="crs-cta-strip-btn">Enroll Now →</Link>
        </div>
      </div>
    </>
  );
};

export default Courses;
